import * as React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { PickupStatsCategories } from '../../../../helpers';
import { IRoundBoxScoreDto } from '../../../../WorldDoomLeague';
import MatchRoundPickupsTable from './MatchRoundPickupsTable';

interface MatchRoundPickupsTabsViewProps {
    category: PickupStatsCategories;
    perRoundBoxScore: IRoundBoxScoreDto;
    categoriesObject: PickupStatsCategories[];
    activeRound: number;
};

const MatchRoundPickupsTabsView = (props: MatchRoundPickupsTabsViewProps) => {

    return (
        <React.Fragment>
            <TabContent activeTab={props.category}>
                {props.categoriesObject && props.categoriesObject.map((s, idx) => (
                    <TabPane tabId={s} key={idx}>
                        <MatchRoundPickupsTable activeCategory={props.category} perRoundBoxScore={props.perRoundBoxScore} activeRound={props.activeRound} />
                    </TabPane>
                    ))}
            </TabContent>
        </React.Fragment>);
};

export default MatchRoundPickupsTabsView;